import eventTypes from "@/events/event-types";
import store from "@/store";
import types from "@/store/types";
var AppFooter = /** @class */ (function () {
    function AppFooter(el) {
        console.log("[create] AppFooter");
        this._el = el;
    }
    AppFooter.prototype.setup = function () {
        this._setNativeEvents();
        this._commitHeight();
    };
    AppFooter.prototype.teardown = function () {
        this._clearNativeEvents();
        delete this._el;
        delete this._onResize;
    };
    AppFooter.prototype._setNativeEvents = function () {
        var _this = this;
        this._onResize = function () { return _this._commitHeight(); };
        window.addEventListener(eventTypes.RESIZE, function () { return _this._commitHeight(); });
    };
    AppFooter.prototype._clearNativeEvents = function () {
        var _this = this;
        window.removeEventListener(eventTypes.RESIZE, function () { return _this._commitHeight(); });
    };
    AppFooter.prototype._commitHeight = function () {
        store.commit(types.SET_FOOTER_HEIGHT, { height: this._el.clientHeight });
    };
    return AppFooter;
}());
export default AppFooter;
